<template>
  <div class="coupon-content" id="person-coupon">
    <!-- tab切换 -->
    <div class="coupon-tab">
      <nav class="flex">
        <div
          v-for="(tab, index) in tabs"
          class="tab"
          :key="index"
          @click="activeTab(index)"
          :class="{ active: activeIndex === index, 'border-l': activeIndex === index && activeIndex > 0 }"
        >
          <span class="item" :class="{ active: activeIndex === index, 'no-border': activeIndex - 1 === index }">{{
            tab.text
          }}</span>
        </div>
        <div class="flex-grow border-b"></div>
      </nav>
    </div>
    <div v-if="list && list.length > 0">
      <!-- 未使用  已使用   已过期  -->
      <div class="item-box">
        <el-row class="item">
          <el-col
            :span="8"
            v-for="(item, index) in list"
            :key="index"
            :class="activeIndex == 0 ? 'item-img-envelopeCashpng' : 'item-img-noenvelopeCashpng'"
          >
            <div class="cash">
              <div
                :class="item.consumeConditionValue ? 'number' : 'number2'"
                v-if="item.model != 2 && item.worth && item.worth !== 'null'"
              >
                <!-- 通用券为0 时，显示图片 start -->
                <div v-if="item.worth == 0" class="img_detail">
                  <img :src="activeIndex == 0 ? couponDetailImg : couponGreyImg" alt="" class="img_40" />
                </div>
                <!-- 通用券为0 时，显示图片 end -->
                <div v-else :class="activeIndex == 0 ? 'worth worth-color' : 'worth'">{{ item.worth / 100 }}</div>
                <div v-if="item.consumeConditionValue" :class="activeIndex == 0 ? 'massacg massacg-color' : 'massacg'">
                  满 {{ item.consumeConditionValue / 100 }} 元可用
                  {{ item.maximumDeductionAmount ? `，最高抵扣${item.maximumDeductionAmount / 100}元` : '' }}
                </div>
              </div>
              <div
                :class="item.consumeConditionValue ? 'number' : 'number2'"
                v-else-if="item.model == 2 && item.discount !== 'null'"
              >
                <div :class="activeIndex == 0 ? 'worth worth-color' : 'worth'">{{ item.discount / 10 }}折</div>
                <div v-if="item.consumeConditionValue" :class="activeIndex == 0 ? 'massacg massacg-color' : 'massacg'">
                  满 {{ item.consumeConditionValue / 100 }} 元可用
                  {{ item.maximumDeductionAmount ? `，最高抵扣${item.maximumDeductionAmount / 100}元` : '' }}
                </div>
              </div>
              <div v-else class="img_detail">
                <div>
                  <img src="../../assets/images/coupon/coupon-detail.png" alt="" class="img_40" />
                </div>
              </div>
            </div>
            <div class="information">
              <div class="information-text">
                <span v-if="item.activeState == '0' && activeIndex == 0" class="activation">未激活</span>
                <span :class="item.activeState == '0' ? 'text2' : 'text'">{{ item.name }}</span>
              </div>
              <img
                src="../../assets/images/coupon/beyond.png"
                alt=""
                class="imgs"
                v-if="endTime(item.serviceTime, item.validityEndTime) && activeIndex == 0"
              />
              <img
                src="../../assets/images/coupon/newArrival.png"
                alt=""
                class="imgs"
                v-else-if="startTime(item.serviceTime, item.createTime) && activeIndex == 0"
              />
              <div v-else>
                <!-- expired 过期  Used-->
                <img src="../../assets/images/coupon/Used.png" alt="" class="imgsUsed" v-if="activeIndex == 1" />
                <img
                  src="../../assets/images/coupon/expired.png"
                  alt=""
                  class="imgsUsed"
                  v-else-if="activeIndex == 2 && item.couponState == '4'"
                />
                <img
                  src="../../assets/images/coupon/invalid.png"
                  alt=""
                  class="imgsUsed"
                  v-else-if="activeIndex == 2 && (item.couponState == '6' || item.couponState == '8')"
                />
              </div>
              <div class="term">
                有效期至：<span>{{ setTime(item.validityEndTime) }}</span>
              </div>
              <div class="detailed" @click="detailedModal(item)">详细说明 ></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="next">
        <!-- 分页  -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="12"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 无数据 -->
    <div v-else>
      <div class="imgBox">
        <img src="../../assets/images/coupon/noData.png" alt="" />
        <div class="imgText">暂无相关的优惠券</div>
      </div>
    </div>
    <!-- 卡券 详情提示框 -->
    <el-dialog :visible.sync="IsDetailedModal" width="410px" id="DetailedModal" :before-close="closeBtn">
      <div class="modalBox">
        <div>
          <img
            src="../../assets/images/coupon/beyond.png"
            alt=""
            class="imgs"
            v-if="endTime(AfferentList.serviceTime, activeList.validityEndTime) && activeIndex == 0"
          />
          <img
            src="../../assets/images/coupon/newArrival.png"
            alt=""
            class="imgs"
            v-else-if="startTime(AfferentList.serviceTime, activeList.createTime) && activeIndex == 0"
          />
          <!-- <div v-else class="modalImgs">
            <img src="../../assets/images/coupon/Used.png" alt="" class="imgsUsed" v-if="activeIndex == 1" />
            <img src="../../assets/images/coupon/expired.png" alt="" class="imgsUsed" v-else-if="activeIndex == 2" />
          </div> -->
        </div>
        <div class="top">
          <div class="title">
            <span v-if="activeList.activeStatus == '0' && activeIndex == 0" class="activation">未激活</span>
            <span :class="activeList.activeStatus == '0' ? 'text2' : 'text'">{{ activeList.name }}</span>
          </div>
          <div class="cash">
            <!-- 券基础类型(1-现金券,2-折扣券,3-随机券,4-兑换券,5-膨胀券) -->
            <div
              :class="activeList.consumeConditionValue ? 'number' : 'number2'"
              v-if="AfferentList.model != 2 && activeList.worth && activeList.worth !== 'null'"
            >
              <div
                class="worth-detail"
                v-if="activeList.worth && activeList.worth !== 'null' && activeList.worth !== '0'"
              >
                <span class="worth-type">￥</span>
                <!-- {{ activeList.worth && activeList.worth !== 'null' ? activeList.worth / 100 : '0' }} -->
                <span>{{ activeList.worth / 100 }}</span>
              </div>
              <!-- 占位 start -->
              <div v-else style="height: 65px;"></div>
              <!-- 占位 end -->
              <div v-if="activeList.consumeConditionValue" class="massacg">
                满 {{ activeList.consumeConditionValue / 100 }} 元可用
                {{ activeList.maximumDeductionAmount ? `，最高抵扣${activeList.maximumDeductionAmount / 100}元` : '' }}
              </div>
              <div v-if="activeList.rightsDescription && activeList.classify === 1" class="rightDesc massacg">
                {{ activeList.rightsDescription }}
              </div>
            </div>
            <div
              :class="activeList.consumeConditionValue ? 'number' : 'number2'"
              v-else-if="AfferentList.model == 2 && activeList.discount && activeList.discount !== 'null'"
            >
              <div class="worth-detail discout-detail">
                {{ activeList.discount / 10 }} <span class="worth-discount">折</span>
              </div>
              <div v-if="activeList.consumeConditionValue" class="massacg">
                满 {{ activeList.consumeConditionValue / 100 }} 元可用
                {{ activeList.maximumDeductionAmount ? `，最高抵扣${activeList.maximumDeductionAmount / 100}元` : '' }}
              </div>
              <div v-if="activeList.rightsDescription" class="rightDesc massacg">
                {{ activeList.rightsDescription }}
              </div>
            </div>

            <div v-else class="img_detail">
              <div>
                <img src="../../assets/images/coupon/coupon_red.png" alt="" class="img_40" />
              </div>
              <div v-if="activeList.consumeConditionValue" class="massacg">
                满 {{ activeList.consumeConditionValue / 100 }} 元可用
                {{ activeList.maximumDeductionAmount ? `，最高抵扣${activeList.maximumDeductionAmount / 100}元` : '' }}
              </div>
              <div v-if="activeList.rightsDescription" class="rightDesc massacg">
                {{ activeList.rightsDescription }}
              </div>
            </div>
          </div>
        </div>
        <div class="Line"></div>
        <div class="dimensionalBarcode" v-if="activeList.status === '1' && activeList.brand != null">
          <img src="https://oss.hlcode.cn/server/2021/05/19/eve1621414198993.png" />
          <div class="tips">经销商扫码核销</div>
        </div>
        <div class="dimensionalBarcode" v-if="activeList.status === '1' && activeList.classify === 1">
          <div ref="qrCodeDiv" id="qrcode" class="qrcodeBox"></div>
          <div class="tips">经销商扫码核销</div>
        </div>
        <div
          :class="activeList.status === '1' && activeList.classify === 1 ? 'detailedsTwo' : 'detaileds'"
          :style="
            activeList.status === '1' &&
            activeList.classify === 1 &&
            ((activeList.activeStatus == '1' &&
              (activeList.classify == 2 || activeList.classify == 3) &&
              activeIndex == 0) ||
              (activeList.activeStatus == '0' && activeIndex == 0))
              ? 'max-height:113px'
              : 'max-height:150px'
          "
        >
          <div class="overflowY"></div>
          <!--  activeList.classify卡券类型：1、整车券，2、售后保养券；3、精品备件券，4、现金 红包； -->
          <!-- <div v-if="activeList.status == 1 && activeList.classify == 1">
            提车经销商：
            <span>{{ activeList.name }}</span>
          </div> -->
          <div>
            卡券号：
            <span>{{ activeList.couponCode }}</span>
          </div>
          <div>
            卡券类型：
            <span>{{ activeList.brand != null ? '途居露营券' : activeList.typeName }}</span>
          </div>
          <div v-if="activeList.brand != null && activeList.verificationCode">
            核销验证码：
            <span>{{ activeList.verificationCode }}</span>
          </div>
          <!-- 商场过来的有子订单号 -->
          <div v-if="activeList.grantChannel && activeList.brand == null">
            订单编号：
            <span>{{ activeList.grantOrder }}</span>
          </div>
          <div v-if="activeList.vin">
            VIN:
            <span>{{ activeList.vin }}</span>
          </div>
          <div>
            适用平台：
            <span>{{ activeList.brand != null ? activeList.brand : utmCodeLits[activeList.utmCode] }}</span>
          </div>
          <div v-if="activeList.status != 4 && activeList.classify == 1 && activeList.publishOrgs.length > 0">
            指定经销商：
            <div style="margin-left: 30px" v-for="(item, index) in activeList.publishOrgs" :key="index + item">
              {{ item }}
            </div>
          </div>
          <!-- 售后保养券消费类别(1-卡券，2-代金券) -->
          <div v-if="activeList.consumeType && activeList.classify == 2">
            消费类别：
            <span>{{ consumeTypeList[activeList.consumeType] }}</span>
          </div>
          <div>
            有效期：
            <span>{{ setTime(activeList.validityStartTime) }}至{{ setTime(activeList.validityEndTime) }}</span>
          </div>
          <div class="description">
            使用说明：
            {{ activeList.description }}
          </div>
          <!-- 卡券状态(1、待使用，3、已使用，4、已过期，5、消费冻结，6、发放回退，7、已提现,8-回退冻结) -->
          <div class="fotter" v-if="activeList.activeStatus == '2'" @click="subm(activeList)">等待复核中</div>
          <div class="fotters" v-if="activeList.status == '6'">已失效</div>
          <div class="fotters" v-if="activeList.status == '8'">已失效</div>
          <div class="fotters" v-if="activeList.status == '3'">已使用</div>
          <div class="fotters" v-if="activeList.status == '7'">已提现</div>
          <div class="fotters" v-if="activeList.status == '4'">已过期</div>
          <!-- 可转赠卡券（transfer=1）不展示按钮 -->
          <template v-if="`${activeList.transfer}` === '0'">
            <div
              class="fotter"
              v-if="
                activeList.activeStatus == '1' &&
                  (activeList.classify == 2 || activeList.classify == 3) &&
                  activeIndex == 0
              "
              @click="subm(activeList)"
            >
              立即使用
            </div>
            <div
              class="fotter"
              v-if="activeList.activeStatus == '0' && activeIndex == 0"
              @click="activeCoupon(activeList.couponCode, activeList.activityId, activeList.grantChannel)"
            >
              立即激活
            </div>
          </template>
        </div>
      </div>
      <div class="close" @click="closeBtn">
        <img src="../../assets/images/coupon/closePng.png" alt="" />
      </div>
    </el-dialog>
    <el-dialog title="卡券激活" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-select v-model="activeValue" placeholder="请选择VIN" style="width: 100%">
        <el-option v-for="(item, index) in options" :key="item + index" :label="item.vin" :value="item.vin"> </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleSub">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="godCouponDialog" width="30%" :before-close="handleClose2">
      <div class="godCoupon-qrcode">
        <div ref="qrCodeDiv2" id="qrcode2" class="qrcodeBox"></div>
      </div>
      <div class="godCoupon-text">
        <p>请扫描微信二维码</p>
        <p>前往移动端奇瑞官方商城激活</p>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose2">取 消</el-button>
        <el-button type="primary" @click="godCouponSub">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import getCoupon from '@/api/coupon.js'
import getActivity from '@/api/activity.js'
import { getStorage, dateFormate } from '@/lib/utils'
import QRCode from 'qrcodejs2'
import couponDetail from '../../assets/images/coupon/coupon-detail.png'
import couponGrey from '../../assets/images/coupon/coupon-grey.png'

export default {
  name: 'coupon',
  components: {},
  data() {
    return {
      couponDetailImg: couponDetail,
      couponGreyImg: couponGrey,
      loading: false /* loading不可重复点击 */,
      preUrl: '',
      code: '',
      dateFormate,
      currentPage: 1, // 分页初始化
      pageSize: 12,
      pageNo: 1,
      total: 0, //  总数
      IsDetailedModal: false, // i详情
      dialogVisible: false, // 卡券激活
      godCouponDialog: false, // 神券激活弹窗
      active: false,
      activeValue: '', // 选中的Vin
      list: [],
      tabActive: 1, // 接口status
      activeIndex: 0, // tab
      activeList: {},
      AfferentList: {},
      options: [],
      couponId: 0, // 对应的卡券id
      qrcode2: '', // 神券二维码
      tabs: [
        {
          text: '未使用',
          status: 1
        },
        {
          text: '已使用',
          status: 3
        },
        {
          text: '已失效',
          status: 4
        }
      ],
      logisticsOrder: null,
      modelList: {
        1: '现金券',
        2: '折扣券',
        3: '随机券',
        4: '兑换券',
        5: '膨胀券'
      },
      // 卡券渠道(DMS-QD01,官方商城-QD02,购车核销系统-QD03,积分商城-QD04
      utmCodeLits: {
        QD01: 'DMS',
        QD02: '官方商城',
        QD03: '购车核销系统',
        QD04: '积分商城'
      },
      consumeTypeList: {
        //  消费类别(1-卡券，2-代金券)
        1: '卡券',
        2: '代金券'
      }
    }
  },
  methods: {
    // 获取Vin查询账户名下VIN码列表
    getVIN() {
      getCoupon.getlistVin().then((res) => {
        if (res.status === 200) {
          this.options = res.data
          // this.options = res.data.vinList
        }
      })
    },
    // 时间截取
    setTime(data) {
      if (data) {
        let ti = data.split(' ')
        return ti[0]
      }
    },
    // 判断新到
    startTime(data, endTime) {
      var datas = new Date(data).getTime() //
      var endDate = new Date(endTime).getTime() //  开始
      var days = (datas - endDate) / (1 * 24 * 60 * 60 * 1000)
      if (days < 7) {
        // 拿到时间-开始时间
        return true
      } else {
        return false
      }
    },
    // 判断将要过期
    endTime(data, endTime) {
      var datas = new Date(data).getTime() //
      var endDate = new Date(endTime).getTime() //  结束
      var days = (endDate - datas) / (1 * 24 * 60 * 60 * 1000)
      if (days < 7 && days > 0) {
        // 超过新到 \\ 未开始
        return true
      } else {
        return false
      }
    },
    // 打开modal 并获取 当前优惠券信息
    detailedModal(item) {
      if (this.active) {
        this.AfferentList = item
        this.getCouponItems()
      }
    },
    // 关闭弹窗
    closeBtn() {
      this.IsDetailedModal = false
      this.AfferentList = {}
      this.activeList = {}
    },
    // tab 切换
    activeTab(index) {
      switch (index) {
        case 0:
          this.tabActive = 1
          break
        case 1:
          this.tabActive = 3
          break
        case 2:
          this.tabActive = 4
      }
      this.activeIndex = index
      this.pageNo = 1
      this.currentPage = 1
      this.list = []
      this.getList()
    },
    // 立即提交
    subm(id) {
      let now = new Date()
      let startTime = new Date(Date.parse(id.validityStartTime.replace(/-/g, '/')))
      if (now < startTime) {
        this.$feedback('未到使用时间哦~')
        return false
      }
      if (id.classify === 2) {
        this.$feedback('请出示卡券号去经销商核销')
        // this.closeBtn()
      } else {
        this.closeBtn()
        this.$router.push('/mall')
      }
    },
    // 获取列表
    getList() {
      getCoupon
        .getCouponList({
          status: this.tabActive,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        .then((res) => {
          if (res.status === 200) {
            this.list = res.data.data
            this.total = res.data.total
            this.active = true
          }
        })
    },
    // 获取详情
    getCouponItems() {
      if (!this.loading) {
        this.loading = true
        getCoupon.getCouponItem({ couponCode: this.AfferentList.couponCode }).then(
          (res) => {
            if (res.status === 200) {
              this.loading = false
              this.activeList = res.data
              // 有brand字段并且有值说明这个优惠券是 途居
              //   this.activeList.brand = 'test'
              this.IsDetailedModal = true
              //  核销二维码
              if (this.activeList.status === '1' && this.activeList.classify === 1) {
                let userInfo = getStorage('userInfo')
                this.preUrl = getStorage('domain', 'localStorage').COUPON_Writeoff
                let url = `${this.preUrl}/check?phoneNumber=${userInfo.mobile}&couponCode=${this.activeList.couponCode}&orderParentId=${this.activeList.grantOrder}`
                this.createQRCode(url, this.$refs.qrCodeDiv)
              }
            }
          },
          (err) => {
            this.loading = false
            if (err.status === 4008) {
              this.$feedback('卡券已被好友领取')
              this.getList()
            }
          }
        )
      } else {
      }
      // getCoupon.getCouponItem({ couponCode: this.AfferentList.couponCode }).then((res) => {
      //   if (res.status === 200) {
      //     this.activeList = res.data
      //     this.IsDetailedModal = true
      //     //  核销二维码
      //     if (this.activeList.status === '1' && this.activeList.classify === 1) {
      //       let userInfo = getStorage('userInfo')
      //       this.preUrl = getStorage('domain', 'localStorage').COUPON_Writeoff
      //       let url = `${this.preUrl}/check?phoneNumber=${userInfo.mobile}&couponCode=${this.activeList.couponCode}&orderParentId=${this.activeList.grantOrder}`
      //       this.createQRCode(url, this.$refs.qrCodeDiv)
      //     }
      //   }
      // })
    },
    // 二维码生成
    createQRCode(url, id) {
      this.$nextTick(() => {
        let qrcode = new QRCode(document.getElementById(`qrcode`), {
          width: 160,
          height: 160,
          // display: 'inline-block',
          text: 'https://www.baidu.com/', // 二维码链接
          colorDark: '#333', // 二维码颜色
          colorLight: '#fff', // 二维码背景色
          correctLevel: QRCode.CorrectLevel.L // 容错率    L/M/H
        })
        qrcode.clear() // 清除二维码
        qrcode.makeCode(url) // 生成另一个新的二维码
      })
    },
    // 二维码生成
    createQRCode2(url, id) {
      if (document.getElementById('qrcode2')) {
        document.getElementById('qrcode2').innerHTML = ''
      }
      this.$nextTick(() => {
        let qrcode2 = new QRCode(document.getElementById(`qrcode2`), {
          width: 160,
          height: 160,
          // display: 'inline-block',
          text: 'https://www.baidu.com/', // 二维码链接
          colorDark: '#333', // 二维码颜色
          colorLight: '#fff', // 二维码背景色
          correctLevel: QRCode.CorrectLevel.L // 容错率    L/M/H
        })
        qrcode2.clear() // 清除二维码
        qrcode2.makeCode(url) // 生成另一个新的二维码
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.pageNo = val
      this.getList()
    },
    /**
     * @descripttion: 神券弹窗关闭
     * @Author: cuiyuan
     * @Date: 2021-04-22 14:28:37
     * @param {void}
     * @return {void}
     */
    handleClose2() {
      this.godCouponDialog = false
    },
    /**
     * @descripttion: 神券确定
     * @Author: cuiyuan
     * @Date: 2021-04-22 14:30:22
     * @param {*}
     * @return {*}
     */
    godCouponSub() {},
    // vin关闭
    handleClose() {
      this.dialogVisible = false
    },
    /**
     * @descripttion: 点击立即激活 按钮
     * @Author: cuiyuan
     * @Date: 2021-04-22 14:41:18
     * @param {number} id [卡券id]
     * @param {number} activityId [活动id]
     * @param {string} grantChannel [卡券类型，2是神券]
     * @return {void}
     */
    activeCoupon(id, activityId, grantChannel) {
      if (!this.loading) {
        if (grantChannel === '2') {
          this.loading = true
          getActivity.actDetacheckActTimeValidil({ activityId: activityId }).then(
            (res) => {
              this.loading = false
              if (res.data) {
                const h5mallUrl = getStorage('domain', 'localStorage').h5mallUrl
                let url = `${h5mallUrl}/pages/user/cardcoupon/cardDetail?couponCode=${id}&&TabCur=0`
                this.$nextTick(() => {
                  this.createQRCode2(url, this.$refs.qrCodeDiv2)
                })
                this.godCouponDialog = true
              } else {
                this.$feedback('活动已结束，无法激活此券')
              }
            },
            () => {
              this.loading = false
            }
          )
        } else {
          this.couponId = id
          this.dialogVisible = true
        }
      } else {
      }
    },
    // 激活
    dialogVisibleSub() {
      getCoupon
        .setActiveCoupon({ couponCode: this.activeList.couponCode, vin: this.activeValue })
        .then((res) => {
          if (res.status === 200) {
            this.dialogVisible = false
            this.IsDetailedModal = false
            this.$feedback('激活成功')
            this.pageNo = 1
            this.getList()
          } else {
            this.dialogVisible = false
            this.IsDetailedModal = false
            this.$feedback('激活成功')
            this.pageNo = 1
            this.getList()
          }
        })
        .catch((err) => {
          this.$feedback(err.message)
        })
    }
  },
  created() {
    this.getList()
    this.getVIN()
  }
}
</script>

<style lang="scss" scoped>
.worth-discount {
  font-size: 27px;
  position: relative;
  top: -3px;
}
.discout-detail {
  line-height: 60px;
}
.worth-detail {
  font-size: 50px !important;
  .worth-type {
    font-size: 28px;
  }
}
.rightDesc {
  color: #666666 !important;
  max-width: 368px;
  margin: 0 10px;
  overflow: hidden;
  word-break: keep-all;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.coupon-content {
  background: #ffffff;
  min-height: 640px;
  .flex {
    display: flex;
  }
  nav {
    box-sizing: border-box;
    overflow: hidden;
    .flex-center {
      display: flex;
      align-items: center;
    }
    .border-l {
      border-left: 1px solid #d4d4d4 !important;
    }
    .border-b {
      border-bottom: 1px solid #d4d4d4;
    }
    .flex-grow {
      flex-grow: 1;
    }
    .tab {
      @extend .flex-center;
      width: 127px;
      height: 56px;
      box-sizing: border-box;
      border-bottom: 1px solid #d4d4d4;
      cursor: pointer;
      text-align: center;
      span {
        font-size: 14px;
      }
      &.active {
        border-top: 2px #c6001f solid;
        border-right: 1px #d4d4d4 solid;
        color: #c6001f;
        position: relative;
        border-bottom: none;
        &:before {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          display: inline-block;
          content: '';
          width: 0;
          height: 0;
          border-width: 4px 4px 0;
          border-style: solid;
          border-color: #c6001f transparent transparent;
        }
      }
    }
    .item {
      display: inline-block;
      width: 100%;
      height: 20px;
      line-height: 20px;
      border-right: 1px solid #d4d4d4;
      &.active {
        transform: translateY(-1px);
        border-right: 1px solid #fff;
        font-weight: 600;
      }
      &.no-border {
        border-right: 1px solid #fff;
      }
    }
  }
  .item-box {
    padding: 30px 20px;
    .item {
      // display: flex;
      // justify-content: space-between;
      .item-img-envelopeCashpng {
        height: 120px;
        background: url('../../assets/images/coupon/couponpng.png') no-repeat;
        background-size: 328px 120px;
        margin-bottom: 24px;
        display: flex;
        justify-content: space-between;
      }
      .item-img-noenvelopeCashpng {
        height: 120px;
        background: url('../../assets/images/coupon/nocouponpng.png') no-repeat;
        background-size: 328px 120px;
        margin-bottom: 24px;
        display: flex;
      }
      .cash {
        width: 120px;
        text-align: center;
        .number {
          height: 100%;
          text-align: center;
          font-size: 26px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
          line-height: 36px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          position: relative;
        }
        .worth {
          font-size: 40px;
          margin-top: 25px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          &-color {
            color: #f2ce9b;
          }
        }
        .worth:before {
          content: '¥';
          font-size: 24px;
        }
        .number2 {
          height: 100%;
          text-align: center;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #faf7f5;
          line-height: 60px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          position: relative;
        }
        .massacg {
          text-align: center;
          height: 15px;
          font-size: 15px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          line-height: 23px;
          &-color {
            color: #f2ce9b;
          }
        }
      }
      .img_detail {
        text-align: center;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .img_40 {
          width: 40px;
          height: 40px;
        }
      }
      .information {
        width: 208px;
        height: 100px;
        margin-top: 20px;
        padding-left: 20px;
        position: relative;
        .information-text {
          display: flex;
          .activation {
            display: inline-block;
            width: 37px;
            height: 16px;
            font-size: 10px;
            font-family: SourceHanSansSC-Normal, SourceHanSansSC;
            font-weight: 400;
            color: #ffffff;
            line-height: 16px;
            background: #a2a2a2;
            border-radius: 2px;
            vertical-align: middle;
            padding: 2px 3px;
            margin-right: 4px;
          }
          .text {
            display: inline-block;
            max-width: 140px;
            max-height: 27px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .text2 {
            display: inline-block;
            max-width: 115px;
            max-height: 27px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .imgs {
          width: 57px;
          height: 56px;
          position: absolute;
          top: -19px;
          right: 20px;
        }
        .imgsUsed {
          width: 64px;
          height: 64px;
          position: absolute;
          top: 10px;
          right: 30px;
        }
        .term {
          margin-top: 25px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
        }
        .detailed {
          margin-top: 5px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #df3d36;
          line-height: 20px;
          cursor: pointer;
        }
      }
    }
  }
  .order-tab {
    background: #ffffff;
  }
  .flex-center-clumn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .show-underline {
    color: #666666;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
  }
}
.next {
  text-align: center;
}
.modalBox {
  position: relative;
  width: 410px;
  height: 630px;
  background: url('../../assets/images/coupon/modalBox.png') no-repeat;
  background-size: 410px 630px;
  .imgs {
    width: 57px;
    height: 56px;
    position: absolute;
    top: 19px;
    right: 19px;
  }
  .modalImgs {
    .imgsUsed {
      width: 100px;
      position: absolute;
      top: 60px;
      right: 30px;
    }
  }
  .top {
    width: 410px;
    height: auto;
    padding-top: 70px;
    position: relative;
    .title {
      display: flex;
      text-align: center;
      padding-left: 20px;
      padding-right: 20px;
      justify-content: center;
      align-items: center;
      .activation {
        display: inline-block;
        width: 37px;
        height: 16px;
        font-size: 10px;
        font-family: SourceHanSansSC-Normal, SourceHanSansSC;
        font-weight: 400;
        color: #ffffff;
        line-height: 16px;
        background: #a2a2a2;
        border-radius: 2px;
        vertical-align: middle;
        padding: 2px 3px;
        margin-right: 4px;
      }
      .text {
        width: 285px;
        height: 24px;
        font-size: 26px;
        font-family: SourceHanSansSC-Normal, SourceHanSansSC;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
        word-wrap: break-word;
        word-break: normal;
        overflow: hidden;
        // word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .text2 {
        width: 285px;
        height: 24px;
        font-size: 26px;
        font-family: SourceHanSansSC-Normal, SourceHanSansSC;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
        word-wrap: break-word;
        word-break: normal;
        overflow: hidden;
        // word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .cash {
      height: 128px;
      text-align: center;
      padding-left: 20px;
      padding-right: 20px;
      .number {
        max-width: 100%;
        font-size: 20px;
        font-family: SourceHanSansSC-Normal, SourceHanSansSC;
        font-weight: 400;
        color: #c6001f;
        line-height: 40px;
        word-wrap: break-word;
        word-break: normal;
      }
      .number2 {
        max-width: 100%;
        font-size: 20px;
        font-family: SourceHanSansSC-Normal, SourceHanSansSC;
        font-weight: 400;
        color: #c6001f;
        line-height: 60px;
        word-wrap: break-word;
        word-break: normal;
      }
      .massacg {
        max-width: 370px;
        text-align: center;
        font-size: 14px;
        font-family: SourceHanSansCN-Normal, SourceHanSansCN;
        font-weight: 400;
        color: #c6001f;
        line-height: 23px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        // display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        padding-left: 38px;
      }
      .img_detail {
        text-align: center;
        .img_40 {
          margin-top: 15px;
          width: 40px;
        }
      }
    }
  }
}
.close {
  margin-top: 20px;
  text-align: center;
  background: transparent;
}
.Line {
  width: 326px;
  position: absolute;
  top: 190px;
  left: 41px;
  border: 0.5px dotted #da9d6d;
}
.dimensionalBarcode {
  text-align: center;
  img {
    width: 160px;
    height: 160px;
  }
  .code {
    img {
      width: 160px;
      height: 160px;
    }
  }
  .qrcodeBox {
    display: flex;
    justify-content: center;
  }
  .tips {
    height: 24px;
    font-size: 16px;
    font-family: SourceHanSansHWSC-Regular, SourceHanSansHWSC;
    font-weight: 400;
    color: #c6001f;
    line-height: 24px;
    margin-top: 3px;
    margin-bottom: 10px;
  }
}

.detailedsTwo {
  padding-left: 48px;
  padding-right: 48px;
  color: #666666;
  // max-height: 120px;
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  .description {
    line-height: 20px;
  }

  .overflowY {
    height: 100%;
    width: 4px;
    background-color: #c6001f;
  }
  div {
    font-size: 14px;
    line-height: 22px;
  }
  .fotter {
    cursor: pointer;
    text-align: center;
    position: absolute;
    bottom: 40px;
    left: 47px;
    width: 314px;
    height: 52px;
    line-height: 52px;
    color: #ffffff;
    font-weight: 400;
    font-size: 20px;
    background: #c6001f;
    box-shadow: 0px 7px 17px 0px rgba(198, 0, 31, 0.21);
  }
  .fotters {
    text-align: center;
    position: absolute;
    bottom: 40px;
    left: 47px;
    width: 314px;
    height: 52px;
    line-height: 52px;
    color: #ffffff;
    font-weight: 400;
    font-size: 20px;
    background: #eee;
    box-shadow: 0px 7px 17px 0px rgba(198, 0, 31, 0.21);
  }
}
.detailedsTwo::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.detaileds {
  padding-left: 48px;
  padding-right: 48px;
  color: #666666;
  max-height: 300px;
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  .description {
    line-height: 20px;
  }
  div {
    line-height: 20px;
    margin-bottom: 2px;
  }
  .fotter {
    cursor: pointer;
    text-align: center;
    position: absolute;
    bottom: 40px;
    left: 47px;
    width: 314px;
    height: 52px;
    line-height: 52px;
    color: #ffffff;
    font-weight: 400;
    font-size: 20px;
    background: #c6001f;
    box-shadow: 0px 7px 17px 0px rgba(198, 0, 31, 0.21);
  }
  .fotters {
    text-align: center;
    position: absolute;
    bottom: 40px;
    left: 47px;
    width: 314px;
    height: 52px;
    line-height: 52px;
    color: #ffffff;
    font-weight: 400;
    font-size: 20px;
    background: #eee;
    box-shadow: 0px 7px 17px 0px rgba(198, 0, 31, 0.21);
  }
}
.detaileds::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.imgBox {
  margin-top: 100px;
  text-align: center;
  .imgText {
    margin-top: 20px;
    font-size: 26px;
    font-family: SourceHanSansSC-Normal, SourceHanSansSC;
    font-weight: 400;
    color: #a2a2a2;
  }
}
.godCoupon-text {
  text-align: center;
  line-height: 20px;
  margin: 10px;
}
.godCoupon-qrcode {
  display: flex;
  justify-content: center;
}
</style>
<style lang="scss">
#person-coupon {
  #DetailedModal {
    .el-button--danger {
      background: #c6001f !important;
    }
    .el-button--info {
      background: #000000 !important;
    }
    .el-tabs__header {
      margin: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog,
    .el-pager li {
      background: none;
      box-shadow: none;
    }
  }
}
</style>
